import Qs from 'qs'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'

const createAPIClient = (baseURL: string) =>
  createAuthedHttpClient({
    baseConfig: {
      baseURL,
      paramsSerializer: (params) =>
        Qs.stringify(params, { arrayFormat: 'repeat' }),
    },
  })

export const CustomerAPI = createAPIClient(config.CUSTOMER_API)

export const ConversationAPI = createAPIClient(config.CONVERSATION_API)

export const InboxAPI = createAPIClient(config.INBOX_API)

export const MessagingAPI = createAPIClient(config.MESSAGING_API)

export const ReportAPI = createAPIClient(config.REPORT_API)

export const MetricsAPI = createAPIClient(config.METRICS_API)

export const ReachAPI = createAPIClient(config.REACH_API)

export const AutomationAPI = createAPIClient(config.AUTOMATION_API)

export const AudienceDiscoveryAPI = createAPIClient(
  config.AUDIENCE_DISCOVERY_API
)

export const InsightsAPI = createAPIClient(config.INSIGHTS_API)

export const AccountsAPI = createAPIClient(config.ACCOUNTS_API)

export const TargetingAPI = createAPIClient(config.TARGETING_API)

export const PlaybookReportAPI = createAPIClient(config.PLAYBOOK_REPORT_API)

export const EmailCampaignAPI = createAPIClient(config.EMAIL_CAMPAIGN_API)

export const TicketAPI = createAPIClient(config.TICKET_API)

export const AIPlatformAPI = createAPIClient(config.AI_PLATFORM_API)

export const CubeReportingAPI = createAPIClient(config.CUBE_REPORTING_API)

export const OnboardingAPI = createAPIClient(config.ALL_ABOARD_API)

export const ReviewAPI = createAPIClient(config.REVIEW_API)

export const IntegrationAPI = createAPIClient(config.INTEGRATION_API)

export const SiteConciergeAPI = createAPIClient(config.SITE_CONCIERGE_API)
